import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/hero.css";

const Hero = () => {
  return (
    <section className="hero-section text-center">
      <div className="hero-overlay"></div>
      <div className="container">
        <h1 className="hero-title">Sólyom Dental</h1>
        <p className="hero-subtext">Mert a mosoly érték!</p>
        <a href="#contact" className="btn">
          Időpontfoglalás
        </a>
      </div>
    </section>
  );
};

export default Hero;
